import { Button, Divider, Stack, Typography } from '@mui/material';
import { AxiosError } from 'axios';

import { CfsApi } from '@/api';
import { AppModal, BaseModalProps } from '@/components';
import { ConfirmTypes, useToastStore } from '@/store';

interface ResendNotificationModalProps extends BaseModalProps {
  cfsId: string;
}

const ResendNotificationModal = ({
  open,
  onClose,
  cfsId,
}: ResendNotificationModalProps) => {
  const { updateToast } = useToastStore();

  const handleClose = () => {
    onClose();
  };

  const handleSubmit = () => {
    if (cfsId) {
      CfsApi.resendReadyToDispatchNotification(cfsId)
        .then(() => {
          handleClose();
          updateToast({
            type: ConfirmTypes.SUCCESS,
            open: true,
            message: 'Ready to dispatch notification resent successfully',
          });
        })
        .catch((error: AxiosError) => {
          updateToast({
            type: ConfirmTypes.ERROR,
            open: true,
            message: `Error resending ready to dispatch notification: ${error.message}`,
          });
        });
    }
  };

  return (
    <AppModal open={open} onClose={handleClose} title="Resend Notification">
      <Stack spacing={2}>
        <Typography variant="body1">
          All app users will be notified again with the CFS details. Are you
          sure you want to resend the notification?
        </Typography>
        <Divider />
        <Stack flexDirection="row" justifyContent="end">
          <Button
            variant="outlined"
            color="inherit"
            size="large"
            sx={{ ml: 2 }}
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            type="submit"
            color="error"
            size="large"
            sx={{ ml: 2 }}
            onClick={handleSubmit}
          >
            I Understand
          </Button>
        </Stack>
      </Stack>
    </AppModal>
  );
};

export default ResendNotificationModal;
